import React, { useCallback, useState } from "react";
import { useQuery } from "react-query";

import { DataTable } from "components/ui/DataTable";
import { useColumns } from "./columns";
import { MainContainer } from "components/shared";
import { SettingLayout } from "layouts/SettingLayout";
import { InnerOptions } from "../InnerOptions";
import { useHubChecklistUser } from "hooks/api";
import { useFilterStore, usePaginationStore } from "store/hub/hubChecklistUser";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { HubDeleteChecklistUser } from "../Delete";
import { DataFilter } from "./DataFilter";

import { IHubChecklistUser } from "interfaces/Hub";
import { InHomolog } from "utils/InHomolog";
export const HubListChecklistUser: React.FC = () => {
  const { options } = InnerOptions();
  const { errorHandler } = useErrorHandler();
  const { filtersData } = useFilterStore();
  const { pagination, setPagination } = usePaginationStore();
  const { getListChecklistUsers } = useHubChecklistUser();
  const [toDelete, setToDelete] = useState<IHubChecklistUser | null>(null);

  const handleDelete = (dataToDelete: IHubChecklistUser) => {
    setToDelete(dataToDelete);
  };

  const { columns } = useColumns({ deleteFunc: handleDelete });

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["getListChecklistUsers", filtersData, pagination],
    queryFn: () => getListChecklistUsers(filtersData, pagination),
    onError: errorHandler,
  });

  const onCloseDelete = useCallback(() => {
    setToDelete(() => null);
    refetch();
  }, [refetch]);

  return (
    <MainContainer>
      <InHomolog />
      <SettingLayout options={options} page="hub-checklist-user">
        <DataFilter />
        {toDelete && (
          <HubDeleteChecklistUser
            isOpen={!!toDelete}
            data={toDelete}
            onClose={onCloseDelete}
          />
        )}
        <section>
          <DataTable
            data={data?.users ?? []}
            isLoading={isLoading}
            columns={columns}
            manualPagination={true}
            pagination={data?.pagination ?? {}}
            onPaginationChange={setPagination}
            showControlColumns={false}
          />
        </section>
      </SettingLayout>
    </MainContainer>
  );
};
